<template>
  <div class="header">
    <div
      :class="$route.meta.pageTitle.type ? '' : 'header__homeLogo--top'"
      class="header__homeLogo">
      <div v-if="$route.meta.pageTitle.type">
        <div class="title">
          {{ $route.meta.pageTitle.value }}
        </div>
      </div>

      <template v-else>
        <a
          href="#">
          <img src="@/assets/img/common/astro_logo.png">
        </a>
      </template>

      <template v-if="$route.meta.sideNavType && !$route.meta.sideNavNone">
        <button
          class="header__homeLogo__backBtn"
          @click="historyBack">
          <img src="@/assets/img/common/icon-header-back.svg">
        </button>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Header',

  components: {
  },

  computed: {
  },

  data () {
    return {
    }
  },

  methods: {
    historyBack () {
      this.$router.back(-1)
    }

  }
}
</script>

<style lang="postcss" scoped>
  .header {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    position: fixed;
    z-index: 10;
    box-shadow: 0px 3px 6px 3px rgba(0,0,0,0.10);
    background: #fafafa;
    &--search{
      height: auto;
    }
    &__homeLogo{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 50px;
      text-align: center;
      position: relative;
      .title {
        width: 100%;
        color: #1c1c1c;
        font-weight: bold;
        font-size: 18px;
      }
      a img {
        height: 50px;
      }
      &__backBtn{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue